<template>
  <div class="page-header header-fixed">
    <div class="container">
      <header>
        <h1>{{ __('Dietitians') }}</h1>
      </header>

      <nav class="patient-nav nav-toggle">
        <ul>
          <li class="patient-active" :class="{'active': type === 'active'}">
            <a href="#" @click.prevent="$emit('type', 'active')">
              {{ __('Active') }}
              <span v-if="data">{{ data.active_coaches_count }}</span>
            </a>
          </li>
          <li class="patient-new" :class="{'active': type === 'waiting'}">
            <a href="#" @click.prevent="$emit('type', 'waiting')">
              {{ __('Pending') }}
              <span v-if="data">{{ data.waiting_coaches_count }}</span>
            </a>
          </li>
          <li class="patient-inactive-admin" :class="{'active': type === 'archived'}">
            <a href="#" @click.prevent="$emit('type', 'archived')">
              {{ __('Archived') }}
              <span v-if="data">{{ data.archived_coaches_count }}</span>
            </a>
          </li>
        </ul>
      </nav>

      <VButton href="/novy-terapeut" size="sm" :label="__('New dietitian')" />
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      type: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        data: null
      }
    },
    async mounted() {
      this.data = await axios.get('/terapeute/counts').then(r => r.data.data)
    }
  }
</script>
